import { EqualityCondition } from 'core/flow/entities';

type AnalyticsCondition = Record<string, EqualityCondition>;

export enum AnalyticsType {
  FACEBOOK_PIXEL = 'FACEBOOK_PIXEL',
  BING_ADS = 'BING_ADS',
  TIK_TOK = 'TIK_TOK',
}

interface AnalyticsNumericalId {
  id: string;
}

interface AnalyticsAttribute extends AnalyticsNumericalId {
  condition?: AnalyticsCondition;
}

export type FacebookAnalytics = {
  type: AnalyticsType.FACEBOOK_PIXEL;
  attributes: Array<AnalyticsAttribute>;
};

export type BingAdsAnalytics = {
  type: AnalyticsType.BING_ADS;
  attributes: Array<AnalyticsAttribute>;
};

export type TikTokAnalytics = {
  type: AnalyticsType.TIK_TOK;
  attributes: Array<AnalyticsAttribute>;
};

export type FunnelAnalytics = Array<FacebookAnalytics | BingAdsAnalytics | TikTokAnalytics>;

export const isFacebookPixel = (item: FunnelAnalytics[number]): item is FacebookAnalytics =>
  item.type === AnalyticsType.FACEBOOK_PIXEL;

export const isBingAds = (item: FunnelAnalytics[number]): item is BingAdsAnalytics =>
  item.type === AnalyticsType.BING_ADS;

export const isTikTok = (item: FunnelAnalytics[number]): item is TikTokAnalytics =>
  item.type === AnalyticsType.TIK_TOK;
